import { createSlice } from "@reduxjs/toolkit";

const initialCPLLeaveState = {
    listLoading: false,
    actionsLoading: null,
    totalCount: 0,
    entities: null,
    roles: null,
    centers: null,
    userStatusTypes: null,
    userForEdit: undefined,
    lastError: null,
    userForRead: false,
    assignmentHistory: [],
};


export const callTypes = {
    list: "list",
    action: "action",
};

export const CPLLeaveSlice = createSlice({
    name: "CPLLeave",
    initialState: initialCPLLeaveState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },

        assetRegisterFetched: (state, action) => {
        
  
            const entities = action.payload.data?.data.rows;
           
            const totalResult = action.payload.data?.data.totalResults;
         
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalResult;
           
        },

         asssetAssignmentHistoryFetched: (state, action) => {
            const assignmentHistory = action.payload.data?.data.rows;


            state.actionsLoading = false;
            state.assignmentHistory = assignmentHistory;
            state.error = null;
        },

         //get User By ID
         AssetRegisterFetchedForEdit: (state, action) => {
           
   
            state.actionsLoading = false;
            state.userForEdit = action.payload.userForEdit;
            state.error = null;
        },

      
        AssetRegisterDeleted: (state, action) => {

            state.error = null;
            state.actionsLoading = false;
         
          
            state.entities = state.entities.filter(
                (el) => el.Id !== action.payload.Id
            );
        },





        // assetRegisterCreated: (state, action) => {
           
        //     state.actionsLoading = false;
        //     state.error = null;
        //     state.entities.unshift(action.payload);
        // },


        assetRegisterCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
        
            // Clone the payload to avoid direct mutation
            // let payload = JSON.stringify(action.payload);
            // let payloadObj = JSON.parse(payload);
        
            // // If basis_of_gratuityId is 0, set "Gross", if 1, set "Basis"
            // if (payloadObj.basis_of_gratuityId == 0) {
             
            //     payloadObj.basis_of_gratuity = "Gross";
            // } else if (payloadObj.basis_of_gratuityId == 1) {
          
            //     payloadObj.basis_of_gratuity = "Basis";
            // }
        
            // Add the modified payload to the beginning of the entities list
            state.entities.unshift(action.payload);
        },
        



        assetRegisterUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            // state.entities.push(action.payload)
            
          
            state.entities = state.entities.map((entity) => {
                
                //const payload = { ...action.payload };
                let payload = JSON.stringify(action.payload)
                let payloadObj = JSON.parse(payload);
                let finalObj = JSON.parse(payloadObj.updatedAssetRegister);
                if (entity.Id === finalObj.Id) {
                    return finalObj; //action.payload.updatedAssetRegister;
                }
                return entity;
            });
           
        },


        
        

    },
});
